import { render, staticRenderFns } from "./DKBLI.vue?vue&type=template&id=2c07b53a&"
import script from "./DKBLI.vue?vue&type=script&lang=js&"
export * from "./DKBLI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports